module.exports = __webpack_public_path__ + "media/images/mobile/abouts/18-f01a8855156970a682073490437d2bb1.png";